import { formatDateTime } from "@/common/utils/formatters";
import { ArrowBigRightIcon, BriefcaseBusinessIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { NegotiationData } from "../types/negotiations.type";
import { negotiationStatus } from "../constants/negotiationStatus.constant";
import { getDateDiffInDays } from "@/common/utils/date";
import { ImageWithDisplayName } from "@/common/components/ImageWithDisplayName";

export class NegotiationsTransformer {
  static tableTransformer() {
    return (negotiations: NegotiationData[]) => {
      return negotiations.map((negotiation) => {
        return {
          ...negotiation,
          _className: negotiation.status === 'awaiting_establishment_response' && 'bg-yellow-op-2',
          status: negotiation.status ? negotiationStatus[negotiation.status] : '',
          created_at: negotiation.created_at ? formatDateTime(new Date(negotiation.created_at)) : '',
          accepted_at: negotiation.accepted_at ? formatDateTime(new Date(negotiation.accepted_at)) : '',
          due_for: negotiation.due_at ? `${getDateDiffInDays(new Date(), new Date(negotiation.due_at))} dias` : '',
          client_company: (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={negotiation.client_company?.general_information?.company_logo?.url}
              displayName={negotiation.client_company?.general_information?.fantasy_name}
            />
          ),
          actions: (
            <Link to={`/negotiations/${negotiation.id}`}>
              <ArrowBigRightIcon />
            </Link>
          ),
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (negotiations: NegotiationData[]) => {
      return negotiations.map((negotiation) => ({
        route: `/negotiations/${negotiation.id}`,
        items: [
          ['Código', negotiation.number],
          ['Status', negotiation.status ? negotiationStatus[negotiation.status] : ''],
          ['Empresa', negotiation.client_company?.general_information?.fantasy_name || ''],
        ],
      }));
    };
  }
}
